import auth from './modules/auth'
import registries from './modules/registries'
import attachments from './modules/attachments'
import actions from './modules/actions'
import sections from './modules/sections'
import notifications from './modules/notifications'

export default {
  auth,
  registries,
  attachments,
  actions,
  sections,
  notifications,
}
